$(function () {
  var ww = $(window).width();

  // product image carousels
  var mainOpts = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    lazyLoad: "ondemand",
    arrows: false,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          dots: true,
        }
      },
      {
        breakpoint: 1150,
        settings: {
          dots: false,
        }
      },
      {
        breakpoint: 767,
        settings: {
          dots: true,
        }
      }
    ]
  };

  var thumbOpts = {
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: false,
    asNavFor: ".js-pd-large-images",
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1300,
        settings: "slick"
      },
      {
        breakpoint: 1150,
        settings: "slick"
      },
      {
        breakpoint: 767,
        settings: "slick"
      }
    ]
  };

  var main = $(".js-pd-large-images");
  var largeImages = $(".pd-large-image");
  var zoomable = $(".js-pd-zoom");
  var zoom;
  var saveNotesBtn = $("#js-save-notes-btn");

  main.on("init", function () {
    // add zoomer on initial slide
    if (ww > 992) {
      var firstImage = zoomable.eq(0);
      firstImage.find(".js-pd-detail-image-img").data("loaded", 1);
      zoom = initZoom(firstImage);
    }
  });

  function initZoom(el) {
    return el.zoom({
      callback: function zoomImgLoaded() {
        // console.log('zoom image ready, show zoom icon');
        $(this)
          .parents(".js-pd-zoom")
          .addClass("zoom-ready");
      }
    });
  }


  var links = $(".js-pd-large-images").find(".js-view-gallery");
  if ($(".thumbnail-more.pd-thumb-img").length) {
    // Add thumbnail more item to open the dialog
    links.push($(".thumbnail-more.pd-thumb-img")[0]);
  }
  links.on("click", function viewGallery(e) {

    var productDiv = document.getElementById("pd-details-section");
    var sku = productDiv.dataset["code"];

    e.preventDefault();
    var isLoadedOnce = productDiv.dataset["loadedOnce"];

    if (!isLoadedOnce) {
      $.get("image-fullpage-viewer?itemcode=" + sku).then(function (response) {
        $("#image-viewer .modal-content").html(response);
        $("#image-viewer").scrollspy({ target: "#thumb-list", offset: 10 });
        $("#image-viewer").data(
          "img-id",
          e.target.parentElement.href.split("#")[1]
        );
        $("#image-viewer").modal("show");
        productDiv.dataset["loadedOnce"] = true;
      });
    } else {
      $("#image-viewer").data(
        "img-id",
        e.target.parentElement.href.split("#")[1]
      );
      $("#image-viewer").modal("show");
    }
    return false;
  });

  $("#image-viewer").on("shown.bs.modal", function (e) {
    var hash = "#" + $(e.target).data("img-id");
    $("#image-viewer").animate(
      {
        scrollTop: $(hash).offset().top
      },
      200,
      function () {
        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      }
    );
  });
  // initialize slick on window load
  // so the blank image issue is resolved
  window.addEventListener('load', function (){
    $(".js-pd-thumb-images").slick(thumbOpts);
    main.slick(mainOpts);
  });

  if (ww > 992) {
    main.on("beforeChange", function () {
      // remove zoom on outgoing slide
      zoom.trigger("zoom.destroy");
    });

    main.on("afterChange", function (e, slider, s) {
      // add zoom to new slide
      if (
        zoomable
          .eq(slider.currentSlide)
          .find(".js-pd-detail-image-img")
          .data("loaded")
      ) {
        zoom = initZoom(zoomable.eq(s));
      }
    });

    main.on("lazyLoaded", function (e, slider, img, src) {
      $(img).data("loaded", 1);
      zoom = initZoom(zoomable.eq(slider.currentSlide));
    });
  }

  // add to cart
  var queryString;
  var form = $("#main_order_form");
  var popCart = $("#js-pop-cart-container");

  popCart.on("click", "#js-pc-close-btn", function (e) {
    e.preventDefault();
    popCart.hide();
  });

  popCart.on("click", function () {
    popCart.hide();
  });

  form.ajaxForm({
    beforeSubmit: function showRequest(formData, jqForm, options) {
      queryString = formData;
    },
    success: function () {
      var updateUrl = form.data("cart-update-url");
      var cartpost = $.post(updateUrl, queryString, null, "json");
      cartpost.done(function (data) {
        var cp_json = data;

        popCart.html(cp_json.cart_html);

        // show the pop cart
        popCart.fadeIn(200, function () {
          // close popCart if Esc key is pressed
          $("body").on("keydown", function (e) {
            if (e.keyCode === 27) {
              popCart.hide();
            }
          });
        });

        var timerID = setTimeout(function () {
          if (popCart.is(":visible")) {
            popCart.fadeOut(300);
          }

          // remove keydown event listener when it's no longer needed
          $("body").off("keydown");
        }, 5000);

        // update the item count in the site header
        if (cp_json.nitems > 0) {
          $(".js-item-count").text(cp_json.nitems);
        }
      });
    }
  });

  //Google Analytics event tracking
  //
  //Item click in product tiles recommended or recently viewed.
  $(".product-tile-link").on("click", function (e) {
    var itemData = $(this).data();
    //console.log("whole thing code: " , itemData);
    if ("gtag" in window) {
      gtag("event", "select_content", {
        content_type: "product",
        items: [itemData]
      });
      // GA4 ONLY, as the above is not compatible
      if ("GOOGLE_GA4_ID" in window) {
        gtag("event", "select_item", {
          send_to: GOOGLE_GA4_ID,
          item_list_name: itemData.item_list_name,
          item_list_id: itemData.item_list_id,
          items: [itemData]
        });
      }
    }
  });

  //Item add to cart click.
  $(".js-flypage-add-to-cart").on("click", function (e) {
    var button = $(this);
    // console.log('add to cart button clicked');

    if ("fbq" in window) {
      // console.log('tracking add to cart (FB pixel)');
      fbq("track", "AddToCart", {
        content_name: button.data("name"),
        content_ids: [button.data("sku")],
        content_type: "product",
        value: button.data("price"),
        currency: "USD"
      });
      // console.log('name', button.data('name'), 'sku', button.data('sku'), 'price', button.data('price'));
    }
  });

  // add to wishlist
  $(".js-addtolist").on("click", function (e) {
    e.preventDefault();
    var link = $(this);
    var url = link.data("wishlist-url");
    var sku = link.data("sku");
    var mv_qty = $("#mv_order_quantity").val();
    fetch(url + sku)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.error) {
          if (data.error === "User must be logged in!") {
            $("#wishlist_msg")
              .removeClass("success-txt")
              .addClass("error-txt");
            $("#wishlist_msg")
              .html(
                "Please <a href='/new_account.html'>Create an account</a> or <a href='/login.html'>Sign In</a> to use the wishlist!"
              )
              .show()
              .delay(5000)
              .fadeOut(2000);
          }
          return;
        }
        $("#wishlist_msg")
          .removeClass("error-txt")
          .addClass("success-txt");
        if (url.indexOf("remove") > -1) {
          $(".addtolist-wrapper.remove")
            .removeClass("show")
            .addClass("hide");
          $(".addtolist-wrapper.add")
            .removeClass("hide")
            .addClass("show");
          $("#wishlist_msg")
            .text("Removed from wishlist.")
            .show()
            .delay(5000)
            .fadeOut(2000);
        } else {
          $(".addtolist-wrapper.remove")
            .removeClass("hide")
            .addClass("show");
          $(".addtolist-wrapper.add")
            .removeClass("show")
            .addClass("hide");
          $("#wishlist_msg")
            .text("Added to wishlist.")
            .show()
            .delay(5000)
            .fadeOut(2000);
        }
      });
    // $('#wishlist_msg').load(url, { 'function': 'added', 'code': sku, 'qty': mv_qty });
  });

  var cb = $("#js-gift-checkbox");

  cb.on("change", function () {
    var isChecked = cb.prop("checked");

    if (isChecked) {
      location.hash = "#gifting-info";
    } else {
      location.hash = "";
    }
    var formFields = $(".js-gift-form-field");

    formFields.each(function (i, v) {
      // make the gift info form fields required (via the HTML5 required
      // attribute) when the checkbox is checked
      if (/Address Line 2/.test(v.placeholder) === false) {
        $(v).prop("required", isChecked ? true : false);
      }
    });
  });

  saveNotesBtn.on("click", function (e) {
    console.log("hello??");
    e.preventDefault();
    var noteData = $("#js-notes-input").val();
    var sku = saveNotesBtn.data("sku") || "";
    var saveNotesMsg = $("#js-save-notes-msg");
    saveNotesMsg.html("&nbsp;");
    saveNotesMsg.attr("class", "save-notes-msg");

    $.ajax({
      url: "/ajax/update-bbdb",
      method: "post",
      data: {
        sku: sku,
        notes: noteData
      },
      success: function (data, tStatus) {
        saveNotesMsg.text(data.msg).addClass("save-notes-msg--" + data.status);
      }
    });
  });

  /**
   * Decrease flypage quantity value
   */
  function increaseQuantity() {
    var current = document.getElementById("mv_order_quantity").value;
    current = +(++current);
    document.getElementById("mv_order_quantity").value = current;
  }

  /**
   * Increase flypage quantity value
   */
  function decreaseQuantity() {
    var current = document.getElementById("mv_order_quantity").value;
    if (current >= 2) {
      current = +--current;
      document.getElementById("mv_order_quantity").value = current;
    }
  }
  /**
   * Add increase and decrease handler for minus and plus icon on quantity section
   */
  document
    .getElementById("quantity-minus")
    .addEventListener("click", decreaseQuantity, { passive: true });
  document
    .getElementById("quantity-plus")
    .addEventListener("click", increaseQuantity, { passive: true });
});

/*
Check if the address is selected in amaryllis page.
return true or false to process or decline the adding to cart action.
*/
function checkAddressSelection() {
  var address = document.getElementById("address").value;
  if (address === "") {
    emitter.emit("show-error");
    document.querySelector('.address-selector').scrollIntoView({ behavior: 'smooth', block: 'center' });
    return false;
  }
  return true;
}

/*
Update SKU for hidden input field to select proper option
for adding to the cart
*/
function updateSku(event) {
  document.getElementsByName("mv_order_item").forEach(function (x) {
    x.value = event.target.dataset.sku;
  });
  showCorrectImageForOption(event.target.dataset.sku);
}
/*
Adding handler for buying options to update SKU
*/
document.getElementsByName("bulb_package").forEach(function (x) {
  x.onclick = updateSku;
});

function showCorrectImageForOption(sku) {
  var imagesWithSrc = document.querySelectorAll(
    'img.js-pd-detail-image-img[src*="' + sku + '"]'
  );
  if (imagesWithSrc.length > 0) {
    var slickIndexWithSrc = imagesWithSrc[0].parentNode.parentElement.dataset.slickIndex;
    $(".js-pd-thumb-images").slick("slickGoTo", slickIndexWithSrc, true);
    $(".js-pd-thumb-images").slick("slickSetOption", { refresh: true });
    return;
  }
  var imagesWithLazySrc = document.querySelectorAll(
    'img.js-pd-detail-image-img[data-lazy*="' + sku + '"]'
  );
  if (imagesWithLazySrc.length > 0) {
    var slickIndexWithLazySrc = imagesWithLazySrc[0].parentNode.parentElement.dataset.slickIndex;
    $(".js-pd-thumb-images").slick("slickGoTo", slickIndexWithLazySrc, true);
    $(".js-pd-thumb-images").slick("slickSetOption", { refresh: true });
  }
}
